<template>
	<el-upload :action="'#'" :http-request="onFileUpload"
		:accept="accept != null ? accept : (fileTypes == null ? '' : fileTypes.join(','))"
		:show-file-list="false" :disabled="disabled" :before-upload="beforeUpload" :multiple="true">
		<slot></slot>
	</el-upload>
</template>

<script>
export default {
	name: "fileUpload",
	data() {
		return {
			loading: null,
			uploadHeaders: {
				"token": sessionStorage.getItem('accessToken')
			}
		}
	},
	props: {
		action: {
			type: String,
			required: false
		},
		// 自定义文件选择器 accept（优先级高于 fileTypes 推导），如 "video/*"；
		// 选择框过滤仅限 UI 层，业务校验由调用方 before 回调完成
		accept: {
			type: String,
			default: null
		},
		fileTypes: {
			type: Array,
			default: null
		},
		maxSize: {
			type: Number,
			default: null
		},
		showLoading: {
			type: Boolean,
			default: false
		},
		isPermanent: {
			type: Boolean,
			default: false
		},
		// 仅选择不上传：before 回调内自行处理文件（返回 false 阻止 el-upload 走 http-request），
		// 用于"选文件后走自定义链路"的入口（如发送视频：需先截帧传封面再传视频）
		manual: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onFileUpload(file) {
			// 展示加载条
			if (this.showLoading) {
				this.loading = this.$loading({
					lock: true,
					text: '正在上传...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			}
			let formData = new FormData()
			formData.append('file', file.file)
			let url = this.action;
			url += this.action.includes("?") ? "&" : "?"
			url += 'isPermanent=' + this.isPermanent;
			this.$http({
				url: url,
				data: formData,
				method: 'post',
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((data) => {
				this.$emit("success", data, file.file);
			}).catch((e) => {
				this.$emit("fail", e, file.file);
			}).finally(() => {
				this.loading && this.loading.close();
			})
		},
		beforeUpload(file) {
			// 校验文件类型
			if (this.fileTypes && this.fileTypes.length > 0) {
				let fileType = file.type;
				let t = this.fileTypes.find((t) => t.toLowerCase() === fileType);
				if (t === undefined) {
					this.$message.error(`文件格式错误，请上传以下格式的文件：${this.fileTypes.join("、")}`);
					return false;
				}
			}
			// 校验大小
			if (this.maxSize && file.size > this.maxSize) {
				this.$message.error(`文件大小不能超过 ${this.fileSizeStr}!`);
				return false;
			}
			this.$emit("before", file);
			// manual 模式：仅作为文件选择器，阻止 el-upload 自动上传（before 回调内自行处理）
			return !this.manual;
		}
	},
	computed: {
		fileSizeStr() {
			if (this.maxSize > 1024 * 1024) {
				return Math.round(this.maxSize / 1024 / 1024) + "M";
			}
			if (this.maxSize > 1024) {
				return Math.round(this.maxSize / 1024) + "KB";
			}
			return this.maxSize + "B";
		}
	}
}
</script>

<style></style>